import { useEffect, useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const advantages = [
  {
    icon: 'ri-database-2-line',
    title: '海量数据源',
    description: '聚合全网吃瓜内容，覆盖51吃瓜网站、社交媒体、直播平台等全渠道信息源，确保内容全面覆盖无死角。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新追踪',
    description: '7×24小时持续监控热点事件，网红塌房、黑料爆料的每一个新进展都能第一时间推送给用户。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '权威信息核验',
    description: '专业编辑团队对每一条爆料进行多维度交叉验证，确保呈现给用户的信息真实可靠有据可查。',
  },
];

const reputationItems = [
  { label: '日活跃用户', value: '500万+', icon: 'ri-user-line' },
  { label: '累计爆料文章', value: '10万+', icon: 'ri-file-text-line' },
  { label: '网红追踪名单', value: '3000+', icon: 'ri-radar-line' },
  { label: '日均更新内容', value: '200+', icon: 'ri-refresh-line' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    document.title = '关于我们 | 吃瓜网站线路一 | 品牌介绍 口碑 联系方式';
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpValue = (formData.get('website_alt') as string || '').trim();
    if (hpValue) {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          body.append(key, value as string);
        }
      });

      const res = await fetch('http://91blw.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed && typeof (parsed as Record<string, unknown>).meta === 'object'
          ? ((parsed as Record<string, { message?: string }>).meta?.message || '')
          : '';
        setFormError(serverMsg || '提交失败，请稍后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          'name': '关于我们 - 吃瓜网站线路一',
          'description': '吃瓜网站线路一品牌介绍、口碑评价与联系方式',
          'url': 'http://91blw.cn/about',
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://91blw.cn/' },
              { '@type': 'ListItem', 'position': 2, 'name': '关于我们', 'item': 'http://91blw.cn/about' },
            ],
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          'mainEntity': [
            {
              '@type': 'Question',
              'name': '吃瓜网站线路一是什么？',
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': '吃瓜网站线路一是一个专注于娱乐八卦、网红塌房、黑料爆料的聚合平台，提供51吃瓜网站入口、在线吃瓜、每日大赛追踪等内容服务。',
              },
            },
            {
              '@type': 'Question',
              'name': '如何访问51吃瓜网站入口？',
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': '直接访问吃瓜网站线路一的首页即可进入51吃瓜网站入口，网站提供在线吃瓜、黑料浏览、网红塌房追踪等全部功能。',
              },
            },
            {
              '@type': 'Question',
              'name': '网站内容多久更新一次？',
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': '吃瓜网站线路一全天候实时更新，平均每天更新超过200条最新吃瓜内容，确保用户不错过任何一个热点事件。',
              },
            },
            {
              '@type': 'Question',
              'name': '如何在网站上找到特定网红的相关内容？',
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': '您可以通过网站的分类导航进入网红塌房栏目，浏览按时间排序的所有网红相关爆料内容。也可以使用浏览器的搜索功能快速定位。',
              },
            },
          ],
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero */}
        <section className="relative w-full h-[280px] md:h-[400px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Chinese%20modern%20office%20team%20collaboration%20abstract%20background%20warm%20peach%20and%20cream%20gradient%20clean%20minimal%20editorial%20aesthetic%20professional&width=1600&height=900&seq=about-hero-chigua&orientation=landscape"
            alt="关于我们 - 吃瓜网站线路一"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="font-heading text-3xl md:text-5xl text-background-50 font-bold mb-4">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto">
              吃瓜网站线路一 · 51吃瓜网站入口 · 您最值得信赖的吃瓜平台
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-3">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        <main>
          {/* Brand Introduction */}
          <section className="py-12 md:py-16">
            <div className="w-full px-4 md:px-6">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 max-w-5xl mx-auto">
                {/* Left - Image */}
                <div className="lg:w-2/5 shrink-0">
                  <span className="inline-block border border-foreground-200 text-foreground-500 text-xs px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
                    关于我们
                  </span>
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Chinese%20modern%20newsroom%20team%20working%20on%20laptops%20warm%20lighting%20collaborative%20atmosphere%20editorial%20office%20clean%20minimal%20design%20professional%20photography&width=600&height=750&seq=about-brand-chigua&orientation=portrait"
                      alt="吃瓜网站线路一团队"
                      className="w-full h-auto object-cover"
                      title="吃瓜网站线路一品牌介绍"
                    />
                  </div>
                </div>

                {/* Right - Text */}
                <div className="lg:w-3/5 flex flex-col justify-center">
                  <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold leading-tight mb-4">
                    打造最专业的<br />吃瓜内容聚合平台
                  </h2>
                  <p className="text-foreground-500 leading-relaxed mb-6">
                    吃瓜网站线路一成立于2024年，是国内领先的娱乐八卦内容聚合平台。我们致力于为广大吃瓜群众提供最新、最快、最全的网红塌房追踪、黑料爆料和每日大赛热点内容。
                  </p>
                  <p className="text-foreground-500 leading-relaxed mb-8">
                    作为51吃瓜网站入口的核心导航站，我们聚合了全网的优质吃瓜资源，覆盖直播吃瓜、在线观看、视频热门等多个维度。无论是搜索吃瓜网址、在线吃瓜还是关注最新吃瓜网站动态，吃瓜网站线路一都是您的不二之选。
                  </p>
                  <div>
                    <Link
                      to="/category/heiliao-baoliao"
                      className="bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap inline-block"
                    >
                      开始吃瓜 <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Reputation / Stats */}
          <section className="py-10 md:py-14 bg-secondary-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-5xl mx-auto">
                <div className="text-center mb-8">
                  <p className="text-foreground-400 text-sm tracking-wide mb-2">品牌口碑</p>
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold">
                    值得信赖的吃瓜平台
                  </h2>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                  {reputationItems.map((item) => (
                    <div key={item.label} className="bg-background-50 rounded-lg p-6 text-center">
                      <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className={`${item.icon} text-xl`}></i>
                      </div>
                      <p className="font-heading text-2xl md:text-3xl text-primary-500 font-bold mb-1">
                        {item.value}
                      </p>
                      <p className="text-xs text-foreground-500">{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Advantages */}
          <section className="py-12 md:py-16">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-5xl mx-auto">
                <div className="mb-10">
                  <p className="text-foreground-400 text-sm tracking-wide mb-2">平台优势</p>
                  <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold">
                    为什么选择我们
                  </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                  {advantages.map((adv) => (
                    <div key={adv.title} className="bg-secondary-50 rounded-lg p-6 md:p-7">
                      <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-50 text-foreground-800 mb-4">
                        <i className={`${adv.icon} text-2xl`}></i>
                      </div>
                      <h3 className="font-heading text-lg text-foreground-900 font-bold mb-2">{adv.title}</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">{adv.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="py-12 md:py-16 bg-secondary-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-5xl mx-auto">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                  <div className="lg:w-1/2">
                    <span className="inline-block border border-foreground-200 text-foreground-500 text-xs px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
                      联系我们
                    </span>
                    <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold mb-4">
                      商务合作 / 内容投稿
                    </h2>
                    <p className="text-foreground-500 leading-relaxed mb-6">
                      如果您有独家的吃瓜线索、网红塌房的一手资料，或者希望与我们进行商务合作，欢迎通过以下方式联系我们。我们承诺对爆料人信息严格保密。
                    </p>
                    <div className="flex flex-col gap-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                          <i className="ri-mail-line text-lg"></i>
                        </div>
                        <div>
                          <p className="text-xs text-foreground-400">电子邮箱</p>
                          <p className="text-sm text-foreground-800">hello@91blw.cn</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                          <i className="ri-wechat-line text-lg"></i>
                        </div>
                        <div>
                          <p className="text-xs text-foreground-400">微信公众号</p>
                          <p className="text-sm text-foreground-800">吃瓜一线线路一</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                          <i className="ri-map-pin-line text-lg"></i>
                        </div>
                        <div>
                          <p className="text-xs text-foreground-400">办公地址</p>
                          <p className="text-sm text-foreground-800">北京市朝阳区互联网产业园A座</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Contact Form */}
                  <div className="lg:w-1/2 bg-background-50 rounded-2xl p-6 md:p-8">
                    <h3 className="font-heading text-xl text-foreground-900 font-bold mb-6">给我们留言</h3>
                    <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="contact-name" className="block text-xs text-foreground-500 mb-1.5">姓名</label>
                          <input
                            type="text"
                            id="contact-name"
                            name="name"
                            className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                            placeholder="请输入您的姓名"
                          />
                        </div>
                        <div>
                          <label htmlFor="contact-email" className="block text-xs text-foreground-500 mb-1.5">邮箱</label>
                          <input
                            type="email"
                            id="contact-email"
                            name="email"
                            className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                            placeholder="请输入您的邮箱"
                          />
                        </div>
                      </div>
                      <div>
                        <label htmlFor="contact-subject" className="block text-xs text-foreground-500 mb-1.5">主题</label>
                        <input
                          type="text"
                          id="contact-subject"
                          name="subject"
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                          placeholder="请输入留言主题"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-xs text-foreground-500 mb-1.5">留言内容</label>
                        <textarea
                          id="contact-message"
                          name="message"
                          rows={4}
                          maxLength={500}
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                          placeholder="请输入您的留言内容（最多500字）"
                        ></textarea>
                      </div>
                      {/* Honeypot */}
                      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="hp-field" />
                      <button
                        type="submit"
                        disabled={formStatus === 'submitting'}
                        className="bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap self-start disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {formStatus === 'submitting' ? '发送中...' : '发送留言'} <i className="ri-send-plane-line ml-2"></i>
                      </button>
                      {formStatus === 'success' && (
                        <p className="text-sm text-green-600">留言已成功发送，我们会尽快回复您！</p>
                      )}
                      {formStatus === 'error' && (
                        <p className="text-sm text-accent-600">{formError}</p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}